export const antennaDpTypeDefs = `

scalar AWSJSON

type AntennaConfig {
  antennaName: String!
  capabilities: [CapabilityState!]!
  isKnownAntenna: Boolean!
  lastUpdatedTimestamp: String!
}

type ArchivedDeviceEventsQueryResponse {
  error: String
  queryExecutionId: String
}

type ArchivedDeviceEventsResultResponse {
  error: String
  events: [AWSJSON]
  nextToken: String
  status: String
}

type CachedDeviceEventsResponse {
  error: String
  events: [AWSJSON]
  totalCount: Int
}

type CapabilityState {
  capabilityId: String!
  capabilityName: String!
  devices: [DeviceState!]!
  status: String!
}

type DeviceConfig {
  antennaName: String!
  deviceInfoEntries: [DeviceInfoDataEntry!]!
  lastUpdatedTimestamp: String!
}

type DeviceInfoDataEntry {
  data: [StringMapEntry!]!
  deviceId: String!
  deviceInfoDataType: String!
}

type DeviceState {
  deviceId: String!
  status: String!
}

type DeviceTelemetryBatch {
  antennaName: String!
  events: [DeviceTelemetryEvent!]!
}

type DeviceTelemetryEvent {
  deviceId: String!
  payload: AWSJSON!
  tableName: String!
  timestamp: String!
}

input DeviceTelemetryEventInput {
  deviceId: String!
  payload: AWSJSON!
  tableName: String!
  timestamp: String!
}

input GetAntennaConfigInput {
  antennaName: String
}

input GetArchivedDeviceEventsQueryInput {
  antennaName: String!
  deviceId: String!
  endTime: Long!
  startTime: Long!
  tableName: String!
}

input GetArchivedDeviceEventsResultInput {
  nextToken: String
  queryExecutionId: String!
}

input GetCachedDeviceEventsInput {
  antennaName: String!
  deviceId: String!
  endTime: Long
  limit: Int
  offset: Int
  startTime: Long
}

input GetDeviceConfigInput {
  antennaName: String
}

input GetLatestDeviceSnapshotInput {
  antennaName: String!
  deviceId: String!
}

type LatestDeviceSnapshotResponse {
  error: String
  payload: AWSJSON
}

scalar Long

type Mutation {
  publishDeviceTelemetryBatch(input: PublishDeviceTelemetryBatchInput!): DeviceTelemetryBatch
}

input PublishDeviceTelemetryBatchInput {
  antennaName: String!
  events: [DeviceTelemetryEventInput!]!
}

type Query {
  getAntennaConfig(cazJustification: String, input: GetAntennaConfigInput!): AntennaConfig
  getArchivedDeviceEventsQuery(input: GetArchivedDeviceEventsQueryInput!): ArchivedDeviceEventsQueryResponse
  getArchivedDeviceEventsResult(input: GetArchivedDeviceEventsResultInput!): ArchivedDeviceEventsResultResponse
  getCachedDeviceEvents(input: GetCachedDeviceEventsInput!): CachedDeviceEventsResponse
  getDeviceConfig(cazJustification: String, input: GetDeviceConfigInput!): DeviceConfig
  getLatestDeviceSnapshot(input: GetLatestDeviceSnapshotInput!): LatestDeviceSnapshotResponse
}

type StringMapEntry {
  key: String
  value: String
}

type Subscription {
  onDeviceTelemetry(antennaName: String!): DeviceTelemetryBatch
}
`;
